module.exports = __webpack_public_path__ + "static/media/hint.5741415c.ogg";